import { Space, Typography } from "antd";

import { useSettingsStore } from "../../store/settings-store";
import { EmptyState } from "../../../../../../components/widgets/empty-state/EmptyState";
import { SpinnerLoader } from "../../../../../../components/widgets/spinner-loader/SpinnerLoader";

function TextViewerPre() {
  const { extractedText, isLoading } = useSettingsStore();

  if (isLoading) {
    return (
      <div className="center">
        <Space direction="vertical">
          <Typography.Text type="secondary">Extracting text...</Typography.Text>
          <SpinnerLoader />
        </Space>
      </div>
    );
  }

  if (!extractedText) {
    return <EmptyState text="No extracted text to display" />;
  }

  return (
    <div className="text-viewer-layout">
      <div className="pad-12">
        <pre className="font-12">{extractedText}</pre>
      </div>
    </div>
  );
}

export { TextViewerPre };
